import Filters from "./Filters";
import DateRangePicker from "../../components/DateRangePicker";
import typography from "./typography";

export default function Header({
  statusFilterVal = 1,
  planFilterVal = 1,
  filterUpdateHandler = () => {},
  range,
  onRangeChange = () => {},
  onRangeClear = () => {},
  hasUserSelectedDate = false,
}) {
  const statusFilterConfig = [
    { id: 1, title: typography.ALL },
    { id: 2, title: typography.ACTIVE },
    { id: 3, title: typography.INACTIVE },
    { id: 4, title: typography.PENDING },
  ];

  const planFilterConfig = [
    { id: 1, title: typography.ALL },
    { id: 2, title: typography.FREE },
    { id: 3, title: typography.PREMIUM },
    { id: 4, title: typography.TRIAL },
  ];

  return (
    <div className="ua-header-con my-4">
      <div className="ua-date-range-con">
        <label className="form-label mb-0">{typography.DATE_RANGE}</label>
        <DateRangePicker
          range={range}
          onChange={onRangeChange}
          onClear={onRangeClear}
          showClearIcon={true}
          hasUserSelectedDate={hasUserSelectedDate}
        />
      </div>
      <Filters
        activeTab={statusFilterVal}
        tabClickHandler={filterUpdateHandler}
        config={statusFilterConfig}
        className="ua-status-filter-con"
        label="Status"
        filterType="status"
      />
      <Filters
        activeTab={planFilterVal}
        tabClickHandler={filterUpdateHandler}
        config={planFilterConfig}
        className="ua-plan-filter-con"
        label="Subscription Plan"
        filterType="plan"
      />
    </div>
  );
}
